/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable react/no-unknown-property */
/* eslint-disable no-useless-escape */
/* eslint-disable react/prop-types */
import React, { Component } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import Header from "../Components/Header";
import SubHeader from "../Components/SubHeader";
import Loader from "../Components/Loader";
import Footer from "../Components/Footer";
import Cookies from "js-cookie";

import "../Styles/ofislerimiz.css";
import {
  CheckCircle,
  CreditCard,
  Calendar,
  Home,
  Gift,
  Phone,
  AlertTriangle,
  Copy,
  Eye,
  EyeOff,
} from "lucide-react";

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    let navigate = useNavigate();
    let params = useParams();
    let [searchParams] = useSearchParams();
    return <Component {...props} router={{ navigate, params, searchParams }} />;
  }

  return ComponentWithRouterProp;
}

class GiftCardPaymentSuccess extends Component {
  constructor(props) {
    super(props);
    this.state = {
      paymentData: {
        phone: "",
        amount: "",
        transactionId: "",
        date: "",
        quantity: 0,
        giftCodes: [],
      },
      showCodes: {},
      copiedCodes: {},
      allCodesCopied: false,
      loading: true,
      error: null,
    };
  }

  componentDidMount() {
    this.loadPaymentData();
  }

  loadPaymentData = () => {
    try {
      const searchParams = this.props.router.searchParams;

      
      const amount = searchParams.get("amount");
      const quantity = parseInt(searchParams.get("quantity")) || 0;
      const transactionId = searchParams.get("transactionId");
      const displayId = searchParams.get("displayId");
      const phone = searchParams.get("phone")
        ? decodeURIComponent(searchParams.get("phone"))
        : "";

      if (!transactionId) {
        this.setState({
          error: "İşlem ID'si bulunamadı",
          loading: false,
        });
        return;
      }

      this.fetchGiftCodeData(transactionId, amount, quantity, phone, displayId);
    } catch (error) {
      console.error("URL parameter hatası:", error);
      this.setState({
        error: "Sayfa parametreleri okunamadı",
        loading: false,
      });
    }
  };

  fetchGiftCodeData = async (
    transactionId,
    amount,
    quantity,
    phone,
    displayId
  ) => {
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL
        }/api/odeme/gift-card-success?transactionId=${encodeURIComponent(
          transactionId
        )}`
      );

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (!data.success) {
        throw new Error(data.error || "Veri yüklenirken hata oluştu");
      }

      this.setState({
        paymentData: {
          phone: data.phone || phone,
          amount: data.amount || amount,
          transactionId: displayId || data.transactionId || transactionId,
          internalTransactionId: transactionId, 
          date: data.date || new Date().toLocaleDateString("tr-TR"),
          quantity: data.quantity || quantity,
          giftCodes: data.giftCodes || [],
        },
        loading: false,
        error: null,
      });

      setTimeout(() => {
        this.showConfetti();
      }, 500);
    } catch (error) {
      console.error("Gift code data fetch error:", error);
      this.setState({
        error: error.message,
        loading: false,
      });
    }
  };

  toggleCodeVisibility = (index) => {
    this.setState((prevState) => ({
      showCodes: {
        ...prevState.showCodes,
        [index]: !prevState.showCodes[index],
      },
    }));
  };

  copyCodeToClipboard = async (code, index) => {
    try {
      await navigator.clipboard.writeText(code);
      this.setState((prevState) => ({
        copiedCodes: {
          ...prevState.copiedCodes,
          [index]: true,
        },
      }));

      setTimeout(() => {
        this.setState((prevState) => ({
          copiedCodes: {
            ...prevState.copiedCodes,
            [index]: false,
          },
        }));
      }, 2000);
    } catch (err) {
      console.error("Kopyalama başarısız:", err);
    }
  };

  copyAllCodes = async () => {
    try {
      const allCodes = this.state.paymentData.giftCodes
        .map((giftCode, index) => `Hediye Kodu ${index + 1}: ${giftCode.code}`)
        .join("\n");

      await navigator.clipboard.writeText(allCodes);

      this.setState({ allCodesCopied: true });

      setTimeout(() => {
        this.setState({ allCodesCopied: false });
      }, 2000);
    } catch (err) {
      console.error("Tüm kodları kopyalama başarısız:", err);
    }
  };

  showConfetti = () => {
    const confettiContainer = document.createElement("div");
    confettiContainer.style.position = "fixed";
    confettiContainer.style.top = "0";
    confettiContainer.style.left = "0";
    confettiContainer.style.width = "100%";
    confettiContainer.style.height = "100%";
    confettiContainer.style.pointerEvents = "none";
    confettiContainer.style.zIndex = "9999";

    document.body.appendChild(confettiContainer);

    for (let i = 0; i < 50; i++) {
      const confetti = document.createElement("div");
      confetti.style.position = "absolute";
      confetti.style.width = "10px";
      confetti.style.height = "10px";
      confetti.style.backgroundColor = [
        "#ff6b6b",
        "#4ecdc4",
        "#45b7d1",
        "#96ceb4",
        "#feca57",
      ][Math.floor(Math.random() * 5)];
      confetti.style.left = Math.random() * 100 + "%";
      confetti.style.animationDuration = Math.random() * 3 + 2 + "s";
      confetti.style.animationName = "confetti-fall";
      confetti.style.animationTimingFunction = "linear";
      confetti.style.animationFillMode = "forwards";

      confettiContainer.appendChild(confetti);
    }

    const style = document.createElement("style");
    style.textContent = `
      @keyframes confetti-fall {
        0% {
          transform: translateY(-100vh) rotate(0deg);
          opacity: 1;
        }
        100% {
          transform: translateY(100vh) rotate(720deg);
          opacity: 0;
        }
      }
    `;
    document.head.appendChild(style);

    setTimeout(() => {
      if (document.body.contains(confettiContainer)) {
        document.body.removeChild(confettiContainer);
      }
      if (document.head.contains(style)) {
        document.head.removeChild(style);
      }
    }, 5000);
  };

  handleGoToHome = () => {
    this.props.router.navigate("/");
  };

  formatPhoneNumber = (phone) => {
    if (!phone) return "";

    const cleanPhone = phone.trim().replace(/\s+/g, "");

    if (cleanPhone.startsWith("+90")) {
      return cleanPhone;
    }

    if (cleanPhone.startsWith("90")) {
      return "+" + cleanPhone;
    }

    if (cleanPhone.startsWith("0")) {
      return "+90" + cleanPhone.substring(1);
    }

    return "+90" + cleanPhone;
  };

  render() {
    const {
      paymentData,
      showCodes,
      copiedCodes,
      allCodesCopied,
      loading,
      error,
    } = this.state;
    const formattedPhone = this.formatPhoneNumber(paymentData.phone);

    if (loading) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

          <div className="offices-container">
            <div
              className="container text-center"
              style={{ padding: "100px 0" }}
            >
              <div
                className="spinner-border text-primary"
                role="status"
                style={{ width: "3rem", height: "3rem" }}
              >
                <span className="sr-only">Yükleniyor...</span>
              </div>
              <h4 style={{ marginTop: "20px", color: "#666" }}>
                Hediye kodlarınız yükleniyor...
              </h4>
            </div>
          </div>

          <Footer />
        </>
      );
    }

    if (error) {
      return (
        <>
          <Loader />
          <SubHeader />
          <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

          <div className="offices-container">
            <div
              className="container text-center"
              style={{ padding: "100px 0" }}
            >
              <AlertTriangle
                size={60}
                color="#dc3545"
                style={{ marginBottom: "20px" }}
              />
              <h2 style={{ color: "#dc3545", marginBottom: "15px" }}>
                Hata Oluştu
              </h2>
              <p
                style={{
                  color: "#666",
                  fontSize: "16px",
                  marginBottom: "30px",
                }}
              >
                {error}
              </p>
              <button
                onClick={this.handleGoToHome}
                style={{
                  background: "#007bff",
                  color: "white",
                  border: "none",
                  padding: "15px 30px",
                  borderRadius: "8px",
                  fontSize: "16px",
                  cursor: "pointer",
                  display: "inline-flex",
                  alignItems: "center",
                }}
              >
                <Home size={20} style={{ marginRight: "10px" }} />
                Ana Sayfaya Dön
              </button>
            </div>
          </div>

          <Footer />
        </>
      );
    }

    return (
      <>
        <Loader />
        <SubHeader />
        <Header isLoggedIn={Cookies.get("token") == null ? false : true} />

        <div className="offices-container">
          <div
            className="offices-header"
            style={{
              background: "linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)",
            }}
          >
            <div className="offices-header-pattern" />

            <div className="container offices-header-container">
              <div className="row">
                <div className="text-center">
                  <div style={{ marginBottom: "20px" }}>
                    <Gift size={80} color="white" />
                  </div>
                  <h6 className="offices-header-subtitle">
                    HEDİYE KODU SATIŞI
                  </h6>
                  <h1 className="offices-header-title">
                    Hediye Kodlarınız Hazır!
                  </h1>
                  <p className="offices-header-description">
                    Hediye kodu satın alma işleminiz başarıyla tamamlandı.
                    Kodlarınızı aşağıda bulabilirsiniz.
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="offices-grid">
            <div className="container">
              <div
                className="row justify-content-center"
                style={{ marginBottom: "30px" }}
              >
                <div className="col-lg-10">
                  <div
                    className="office-warning-card universal-card universal-shimmer"
                    style={{
                      background: "#fff3cd",
                      border: "2px solid #ffc107",
                      borderRadius: "10px",
                    }}
                  >
                    <div
                      className="office-warning-card-content"
                      style={{ padding: "25px" }}
                    >
                      <div
                        style={{ display: "flex", alignItems: "flex-start" }}
                      >
                        
                        <div>
                          <h4
                            style={{
                              color: "#856404",
                              marginBottom: "15px",
                              fontSize: "20px",
                            }}
                          >
                             ⚠️ ÖNEMLİ UYARI HEDİYE KODLARINIZI SAKLAYIN!
                          </h4>
                          <ul
                            style={{
                              color: "#856404",
                              marginBottom: "0",
                              fontSize: "16px",
                              lineHeight: "1.6",
                              paddingLeft: "0px",
                            }}
                          >
                            <li>
                              <strong>
                                Bu hediye kodlarını güvenli bir yerde saklayın!
                              </strong>
                            </li>
                            <li>
                              Kodlarınızı ekran görüntüsü alarak veya not ederek
                              kaydedin
                            </li>
                            <li>
                              Bu sayfa kapatıldığında kodlarınıza tekrar
                              erişemeyebilirsiniz
                            </li>
                            <li>Kodları başkalarıyla paylaşmayın</li>
                            <li>
                              Hediye kodları tek kullanımlıktır ve geri alınamaz
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="row justify-content-center">
                <div className="col-lg-10">
                  <div
                    className="office-card universal-card universal-shimmer"
                    style={{ marginBottom: "40px" }}
                  >
                    <div className="office-card-pattern universal-pattern" />

                    <div
                      className="office-card-content"
                    >
                      <div
                        className="text-center"
                        style={{ marginBottom: "30px" }}
                      >
                        <div
                          style={{
                            background:
                              "linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)",
                            borderRadius: "50%",
                            width: "100px",
                            height: "100px",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            margin: "0 auto 20px",
                          }}
                        >
                          <Gift size={50} color="white" />
                        </div>
                        <h2 style={{ color: "#FF6B6B", marginBottom: "10px" }}>
                          Hediye Kodları Başarıyla Oluşturuldu!
                        </h2>
                        <p style={{ color: "#666", fontSize: "16px" }}>
                          İşlem ID: <strong>{paymentData.transactionId}</strong>
                        </p>
                      </div>

                      <div className="row">
                        <div className="col-md-12">
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              marginBottom: "20px",
                              background: "#f8f9fa",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: "20px" }}
                            >
                              <h4
                                style={{
                                  color: "#333",
                                  marginBottom: "15px",
                                  display: "flex",
                                  alignItems: "center",
                                }}
                              >
                                <CreditCard
                                  size={20}
                                  style={{ marginRight: "10px" }}
                                />
                                İşlem Bilgileri
                              </h4>

                              <div className="row">
                                <div className="col-md-6">
                                  <div style={{ marginBottom: "10px" }}>
                                    <strong>İşlem ID:</strong>{" "}
                                    {paymentData.transactionId}
                                  </div>
                                  <div
                                    style={{
                                      marginBottom: "10px",
                                      display: "flex",
                                      alignItems: "center",
                                    }}
                                  >
                                    <Calendar
                                      size={16}
                                      style={{ marginRight: "5px" }}
                                    />
                                    <strong>Tarih:</strong> {paymentData.date}
                                  </div>
                                  <div style={{ marginBottom: "10px" }}>
                                    <strong>Durum:</strong>
                                    <span
                                      style={{
                                        color: "#4CAF50",
                                        marginLeft: "5px",
                                      }}
                                    >
                                      ✅ Başarılı
                                    </span>
                                  </div>
                                </div>

                                <div className="col-md-6">
                                  <div style={{ marginBottom: "10px" }}>
                                    <strong>Kod Sayısı:</strong>{" "}
                                    {paymentData.quantity} adet
                                  </div>
                                  {paymentData.amount && (
                                    <div style={{ marginBottom: "10px" }}>
                                      <strong>Tutar:</strong>{" "}
                                      {paymentData.amount} TL
                                    </div>
                                  )}
                                  {paymentData.phone && (
                                    <div
                                      style={{
                                        marginBottom: "10px",
                                        display: "flex",
                                        alignItems: "center",
                                      }}
                                    >
                                      <Phone
                                        size={16}
                                        style={{ marginRight: "5px" }}
                                      />
                                      <strong>SMS Gönderildi:</strong>{" "}
                                      <span
                                        style={{
                                          color: "#4CAF50",
                                          marginLeft: "5px",
                                        }}
                                      >
                                        {formattedPhone}
                                      </span>
                                    </div>
                                  )}
                                </div>
                              </div>

                              {paymentData.phone && (
                                <div
                                  style={{
                                    marginTop: "15px",
                                    padding: "10px",
                                    background: "#e3f2fd",
                                    border: "1px solid #2196f3",
                                    borderRadius: "5px",
                                    fontSize: "14px",
                                    color: "#1976d2",
                                  }}
                                >
                                  <strong>Bilgi:</strong> SMS sadece Türkiye
                                  (+90) numaralarına gönderilmektedir. Yurtdışı
                                  numaralarına SMS gönderimi yapılmamaktadır.
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>

                      {paymentData.giftCodes &&
                        paymentData.giftCodes.length > 0 && (
                          <div
                            className="office-info-card universal-card universal-shimmer"
                            style={{
                              padding: "0",
                              marginBottom: "20px",
                              background: "#fff",
                              border: "2px solid #FF6B6B",
                            }}
                          >
                            <div
                              className="office-info-card-content"
                              style={{ padding: "25px" }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  flexDirection: window.innerWidth <= 768 ? "column" : "row",
                                  justifyContent: "space-between",
                                  alignItems: window.innerWidth <= 768 ? "flex-start" : "center",
                                  marginBottom: "20px",
                                  gap: "15px",
                                }}
                              >
                                <h4
                                  style={{
                                    color: "#FF6B6B",
                                    margin: "0",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: window.innerWidth <= 768 ? "18px" : "24px",
                                  }}
                                >
                                  <Gift
                                    size={window.innerWidth <= 768 ? 20 : 24}
                                    style={{ marginRight: "10px" }}
                                  />
                                  HEDİYE KODLARINIZ
                                </h4>

                                <button
                                  onClick={this.copyAllCodes}
                                  style={{
                                    background: allCodesCopied ? "#4CAF50" : "#FF6B6B",
                                    border: "none",
                                    color: "white",
                                    cursor: "pointer",
                                    padding: "10px 15px",
                                    borderRadius: "6px",
                                    display: "flex",
                                    alignItems: "center",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    width: window.innerWidth <= 768 ? "100%" : "auto",
                                    justifyContent: "center",
                                  }}
                                  title="Tüm Kodları Kopyala"
                                >
                                  <Copy
                                    size={16}
                                    style={{ marginRight: "8px" }}
                                  />
                                  {allCodesCopied
                                    ? "Tüm Kodlar Kopyalandı!"
                                    : "Tüm Kodları Kopyala"}
                                </button>
                              </div>

                              <div
                                style={{
                                  maxHeight: "400px",
                                  overflowY: "auto",
                                  paddingRight: window.innerWidth <= 768 ? "0" : "10px",
                                  scrollbarWidth: "thin",
                                  scrollbarColor: "#FF6B6B #f1f1f1",
                                }}
                              >
                                {paymentData.giftCodes.map((giftCode, index) => (
                                  <div
                                    key={index}
                                    style={{
                                      background: "#f8f9fa",
                                      border: "1px solid #dee2e6",
                                      borderRadius: "8px",
                                      padding: window.innerWidth <= 768 ? "15px" : "20px",
                                      marginBottom: "15px",
                                    }}
                                  >
                                    <div
                                      style={{
                                        display: "flex",
                                        flexDirection: window.innerWidth <= 768 ? "column" : "row",
                                        justifyContent: "space-between",
                                        alignItems: window.innerWidth <= 768 ? "flex-start" : "center",
                                        marginBottom: "10px",
                                        gap: "10px",
                                      }}
                                    >
                                      <strong
                                        style={{
                                          color: "#333",
                                          fontSize: window.innerWidth <= 768 ? "14px" : "16px",
                                        }}
                                      >
                                        Hediye Kodu #{index + 1}
                                      </strong>
                                      <span
                                        style={{
                                          background: "#FF6B6B",
                                          color: "white",
                                          padding: "4px 12px",
                                          borderRadius: "20px",
                                          fontSize: "14px",
                                          alignSelf: window.innerWidth <= 768 ? "flex-start" : "auto",
                                        }}
                                      >
                                        {giftCode.value} TL
                                      </span>
                                    </div>

                                    <div
                                      style={{
                                        background: "white",
                                        border: "2px dashed #FF6B6B",
                                        padding: window.innerWidth <= 768 ? "10px" : "15px",
                                        borderRadius: "5px",
                                        marginBottom: "10px",
                                      }}
                                    >
                                      <div
                                        style={{
                                          marginBottom: window.innerWidth <= 768 ? "10px" : "0",
                                        }}
                                      >
                                        <code
                                          style={{
                                            fontSize: window.innerWidth <= 768 ? "14px" : "18px",
                                            fontWeight: "bold",
                                            color: "#FF6B6B",
                                            letterSpacing: window.innerWidth <= 768 ? "1px" : "2px",
                                            wordBreak: "break-all",
                                            display: "block",
                                            textAlign: window.innerWidth <= 768 ? "center" : "left",
                                          }}
                                        >
                                          {showCodes[index]
                                            ? giftCode.code
                                            : "••••-••••-••••"}
                                        </code>
                                      </div>

                                      <div
                                        style={{
                                          display: "flex",
                                          flexDirection: window.innerWidth <= 768 ? "column" : "row",
                                          alignItems: "center",
                                          justifyContent: window.innerWidth <= 768 ? "stretch" : "flex-end",
                                          gap: "10px",
                                          marginTop: window.innerWidth <= 768 ? "10px" : "0",
                                        }}
                                      >
                                        <button
                                          onClick={() => this.toggleCodeVisibility(index)}
                                          style={{
                                            background: "#f8f9fa",
                                            border: "1px solid #dee2e6",
                                            color: "#666",
                                            cursor: "pointer",
                                            padding: window.innerWidth <= 768 ? "10px" : "8px 12px",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "14px",
                                            width: window.innerWidth <= 768 ? "100%" : "auto",
                                          }}
                                          title={showCodes[index] ? "Kodu Gizle" : "Kodu Göster"}
                                        >
                                          {showCodes[index] ? (
                                            <EyeOff size={16} style={{ marginRight: "5px" }} />
                                          ) : (
                                            <Eye size={16} style={{ marginRight: "5px" }} />
                                          )}
                                          {showCodes[index] ? "Kodu Gizle" : "Kodu Göster"}
                                        </button>

                                        <button
                                          onClick={() =>
                                            this.copyCodeToClipboard(giftCode.code, index)
                                          }
                                          style={{
                                            background: copiedCodes[index] ? "#4CAF50" : "#FF6B6B",
                                            border: "none",
                                            color: "white",
                                            cursor: "pointer",
                                            padding: window.innerWidth <= 768 ? "10px" : "8px 12px",
                                            borderRadius: "4px",
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            fontSize: "14px",
                                            fontWeight: "bold",
                                            width: window.innerWidth <= 768 ? "100%" : "auto",
                                          }}
                                          title="Kodu Kopyala"
                                        >
                                          <Copy size={16} style={{ marginRight: "5px" }} />
                                          {copiedCodes[index] ? "Kopyalandı!" : "Kodu Kopyala"}
                                        </button>
                                      </div>
                                    </div>

                                    <div
                                      style={{
                                        fontSize: window.innerWidth <= 768 ? "12px" : "14px",
                                        color: "#666",
                                        textAlign: window.innerWidth <= 768 ? "center" : "left",
                                      }}
                                    >
                                      Bu kodlar kayıt olma sırasında ücretsiz hesap açmak için kullanılır.
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        )}

                      <div
                        className="office-warning-card universal-card universal-shimmer"
                        style={{
                          background: "#e8f5e8",
                          border: "1px solid #4CAF50",
                        }}
                      >
                        <div
                          className="office-warning-card-content"
                          style={{ marginBottom: "0px !important", padding: "20px" }}
                        >
                          <h4
                            style={{ color: "#4CAF50", marginBottom: "10px" }}
                          >
                            Hediye Kodları Kullanım Bilgileri
                          </h4>
                          <ul
                            style={{
                              color: "#333",
                              marginBottom: "0",
                              lineHeight: "1.6",
                              paddingLeft: "0px",
                            }}
                          >
                            <li>
                              Hediye kodlarınızı mobil uygulamamızda
                              kullanabilirsiniz
                            </li>
                            <li>Her kod sadece bir kez kullanılabilir</li>
                            <li>
                              Kodların son kullanma tarihi:{" "}
                              {new Date(
                                Date.now() + 365 * 24 * 60 * 60 * 1000
                              ).toLocaleDateString("tr-TR")}
                            </li>
                            <li>
                              Sorun yaşamanız durumunda müşteri hizmetlerimizle
                              iletişime geçin
                            </li>
                          </ul>
                        </div>
                      </div>

                      <div
                        className="text-center"
                        style={{ marginBottom: "30px"}}
                      >
                        <button
                          onClick={this.handleGoToHome}
                          style={{
                            background:
                              "linear-gradient(135deg, #FF6B6B 0%, #FFE66D 100%)",
                            color: "white",
                            border: "none",
                            padding: "15px 30px",
                            borderRadius: "8px",
                            fontSize: "16px",
                            fontWeight: "bold",
                            cursor: "pointer",
                            display: "inline-flex",
                            alignItems: "center",
                          }}
                        >
                          <Home size={20} style={{ marginRight: "10px" }} />
                          Ana Sayfaya Dön
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <Footer />

        <style jsx>{`
          div::-webkit-scrollbar {
            width: 8px;
          }
          div::-webkit-scrollbar-track {
            background: #f1f1f1;
            border-radius: 4px;
          }
          div::-webkit-scrollbar-thumb {
            background: #ff6b6b;
            border-radius: 4px;
          }
          div::-webkit-scrollbar-thumb:hover {
            background: #e55a5a;
          }
        `}</style>
      </>
    );
  }
}

export default withRouter(GiftCardPaymentSuccess);
